import { render } from "./OrderListItemComponent.vue?vue&type=template&id=8d15a2d2&scoped=true"
import script from "./OrderListItemComponent.vue?vue&type=script&lang=js"
export * from "./OrderListItemComponent.vue?vue&type=script&lang=js"

import "./OrderListItemComponent.vue?vue&type=style&index=0&id=8d15a2d2&lang=scss&scoped=true"

import exportComponent from "/var/www/cose-cashier/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d15a2d2"]])

export default __exports__